// src/data/tenseSchedule.js
// Ab wann welche Zeitform drankommt (Lückentexte, Freie Übersetzung, Verbtraining), je Lernsprache.
//
// Gemessen am Kursfortschritt, nicht an festen Wochen: Wer langsamer lernt, kennt in
// Woche 17 weniger Wörter und bekommt neue Zeitformen entsprechend später. Die
// Schwellen orientieren sich an den Sprachniveaus (A1 15 %, A2 35 %, B1 65 %, siehe
// LEVEL_MILESTONES in totalExp.js).
import { getWeeksTotal } from "./translationPlan";

// Zeitformen je Lernsprache in der Reihenfolge, in der sie dazukommen. `from` = Kursfortschritt
// (0–1) zu Beginn der Woche. Schlüssel = Ordner in public/data/conjugations/ (sprachneutral);
// die spanischen Satz-Spalten (tense_presente …) übersetzt loadSentences.js.
export const TENSE_SCHEDULES = {
  es: [
    { tense: "present", from: 0 },
    { tense: "perfect", from: 0.1 },
    { tense: "preterite", from: 0.15 },
    { tense: "imperfect", from: 0.25 },
    { tense: "future", from: 0.35 },
    { tense: "imperative", from: 0.35 },
    { tense: "conditional", from: 0.5 },
    { tense: "subjunctive_present", from: 0.5 },
    { tense: "subjunctive_imperfect", from: 0.65 },
  ],
  // ohne passé simple und subjonctif imparfait (Schriftsprache); das Imparfait kommt früher
  // als im Spanischen, weil das passé composé die einzige andere Vergangenheit ist
  fr: [
    { tense: "present", from: 0 },
    { tense: "perfect", from: 0.1 },
    { tense: "imperfect", from: 0.2 },
    { tense: "future", from: 0.35 },
    { tense: "imperative", from: 0.35 },
    { tense: "conditional", from: 0.5 },
    { tense: "subjunctive_present", from: 0.5 },
  ],
};

/** Zeitplan der Lernsprache `lang` (ohne Angabe oder unbekannt: Spanisch). */
export function getTenseSchedule(lang) {
  return TENSE_SCHEDULES[lang] || TENSE_SCHEDULES.es;
}

// Alle Zeitformen (die spanische Liste enthält jede, die eine Lernsprache hat)
export const TENSES = TENSE_SCHEDULES.es.map((t) => t.tense);

/** Kursfortschritt (0–1) zu Beginn von Woche `weekIndex` (ab 1). */
export function getCourseProgress(weekIndex, pace) {
  const week = Math.max(1, weekIndex || 1);
  return (week - 1) / getWeeksTotal(pace);
}

/** Erste Woche, in der `tense` drankommt (null, wenn die Lernsprache sie nicht hat). */
export function getTenseStartWeek(tense, pace, lang) {
  const entry = getTenseSchedule(lang).find((t) => t.tense === tense);
  if (!entry) return null;
  // kleine Toleranz gegen Rundungsfehler bei glatten Werten (z. B. 0,5 × 52)
  return Math.ceil(entry.from * getWeeksTotal(pace) - 1e-9) + 1;
}

/** { present: true, perfect: false, … } für Woche `weekIndex`; Zeitformen, die die Lernsprache nicht hat, fehlen. */
export function getAllowedTenses(weekIndex, pace, lang) {
  const progress = getCourseProgress(weekIndex, pace);
  const allowed = {};
  getTenseSchedule(lang).forEach(({ tense, from }) => {
    allowed[tense] = progress + 1e-9 >= from;
  });
  return allowed;
}
